import React from "react";
import ReactApexChart from "react-apexcharts";
import useWindowDimensions from "../../utils/useWindowDimensions";

const MostVisited = ({ Places, Dashboard }) => {
  let { width } = useWindowDimensions();

  let count = [];
  let visits = [];

  for (var i = 0; i < Places.length; i++) {
    visits.push(Places[i].placeId);
    count.push(i + 1);
  }

  let envLabels = Places.map((elem) => {
    let name = elem.placeId
      .split(" ")
      .map((e) => e[0])
      .join("");
    if (name.length === 1) {
      return (name = elem.placeId.split(" ")[0].substring(0, 6));
    }
    return name;
  });

  const sampleChartData = {
    series: [
      {
        name: "Visits",
        data: Places.map((e) => e.visits),
      },
    ],
    options: {
      chart: {
        type: "bar",
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          columnWidth: "25%",
          borderRadius: 5,
        },
      },
      fill: {
        type: "solid",
      },
      grid: {
        row: {
          colors: ["transparent", "transparent"], // Set transparent colors
          opacity: 0.5,
          // smoothing: 10
        },
      },
      xaxis: {
        categories: envLabels,
      },
      tooltip: {
        enabled: true,
        shared: false,
        followCursor: true,
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          return (
            '<div class="custom-tooltip p-2">' +
            "<span>" +
            visits[dataPointIndex] +
            "<br/>" +
            series[seriesIndex][dataPointIndex] +
            " Visits</span>" +
            "</div>"
          );
        },
      },
      colors: ["#CA353B"],
    },
  };

  return (
    <>
      <div id="chart">
        <ReactApexChart
          options={sampleChartData.options}
          series={sampleChartData.series}
          type="bar"
          height={
            Dashboard === "team"
              ? width > 1400 && width < 1700
                ? 235
                : width >= 1700
                ? 280
                : 185
              : width > 1400 && width < 1700
              ? 235
              : width >= 1700
              ? 320
              : 185
          }
        />
      </div>
    </>
  );
};

export default MostVisited;
